import React, { useState, useEffect } from 'react'

import { Button } from 'Components/shared/Button'
import { AutoComplete } from 'Components/shared/Input'
import { ErrorText } from 'Components/shared/Typography'

import { Flex } from 'lese'

import { useInput, runOnEnter } from 'Helpers'
import { toastWithErrorMessage } from 'Helpers/toast'
import VirtualOfficesService from 'Services/virtual-offices'

export default ({ onSelect, buttonText = 'Select Virtual Office' }) => {
  const [errorText, setErrorText] = useState()
  const [virtualOffices, setVirtualOffices] = useState([])

  const titleHook = useInput('')
  const [titleSuggestions, setTitleSuggestions] = useState([])

  useEffect(async () => {
    const newVirtualOffices = await VirtualOfficesService.list().catch(
      toastWithErrorMessage('Failed to get virtual offices')
    )
    setVirtualOffices(newVirtualOffices)
    setTitleSuggestions(newVirtualOffices.map(virtualOffice => virtualOffice.title))
  }, [])

  const selectUser = async () => {
    const selectedVirtualOffice = virtualOffices.find(
      virtualOffice => virtualOffice.title === titleHook.value
    )
    if (!selectedVirtualOffice) return setErrorText('The virtual office was not found')

    const success = await onSelect(selectedVirtualOffice)
    if (typeof success === 'string') return setErrorText(success)
    setErrorText()
    titleHook.reset()
  }

  return (
    <Flex column separation="24px" xAlign="center">
      <AutoComplete
        placeholder="Title"
        suggestions={titleSuggestions}
        {...titleHook.bind}
        onKeyDown={runOnEnter(selectUser)}
        tabIndex={0}
      />
      {errorText && <ErrorText>{errorText}</ErrorText>}
      <Button onClick={selectUser} onKeyDown={runOnEnter(selectUser)}>
        {buttonText}
      </Button>
    </Flex>
  )
}
